import { LoadingIndicationComponent } from '@/app/components/loading-indication/loading-indication.component';
import { OfferMediaDisplayComponent } from '@/app/components/offer-media-display/offer-media-display.component';
import { SkeletonLoadingComponent } from '@/app/components/skeleton-loading/skeleton-loading.component';
import { CompanyUser } from '@/model/company';
import { DatePipe, Location } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { OfferWithImage } from '../../model/offer-with-image';
import { OfferService } from '../../service/offer.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatomoTracker } from 'ngx-matomo-client';
import { OfferLocationDisplayComponent } from '../components/offer-location-display/offer-location-display.component';

@Component({
    selector: 'app-offer-details',
    imports: [
    MatCardModule,
    OfferMediaDisplayComponent,
    LoadingIndicationComponent,
    MatIconModule,
    SkeletonLoadingComponent,
    DatePipe,
    RouterModule,
    OfferLocationDisplayComponent
],
    templateUrl: './offer-details.component.html',
    styleUrl: './offer-details.component.scss'
})
export class OfferDetailsComponent implements OnInit {
  offer!: OfferWithImage;
  isMobileView: boolean;
  company!: CompanyUser;

  loadingStates = {
    offer: true,
    company: true,
  };

  constructor(
    private offerService: OfferService,
    private route: ActivatedRoute,
    private location: Location,
    private _snackBar: MatSnackBar,
    private router: Router,
    private tracker: MatomoTracker
  ) {
    this.isMobileView = window.innerWidth <= 768;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobileView = (event.target as Window).innerWidth <= 768;
  }

  ngOnInit(): void {
    const offerId = this.route.snapshot.paramMap.get('id');
    if (offerId) {
      this.loadOffer(offerId);
      this.loadCompanyDetails(offerId);
    }
    this.isMobileView = window.innerWidth <= 768;
  }

  loadCompanyDetails(offerId: string) {
    this.loadingStates.company = true;
    this.offerService.getCompanyDetailsByOfferId(offerId).subscribe({
      next: (company) => {
        this.company = company;
        this.loadingStates.company = false;
      },
      error: (error) => {
        console.error('Error loading company details', error);
        this.loadingStates.company = false;
      },
    });
  }

  loadOffer(id: string) {
    this.loadingStates.offer = true;
    this.offerService.getOfferById(id).subscribe({
      next: (offer) => {
        this.offer = offer;
        this.loadingStates.offer = false;

        // Track product view in Matomo
        this.tracker.setEcommerceView(
          id, // SKU
          offer.name, // Product name
          offer.categories.map((c) => c.name).join('/'), // Category
          0 // Price
        );
        // Track the page view after setting ecommerce data
        this.tracker.trackPageView();
      },
      error: (error) => {
        console.error('Fehler beim Laden des Angebots', error);
        this._snackBar.open(
          'Dieses Angebot ist nicht verfügbar.',
          'Schließen',
          {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
          }
        );
        this.router.navigate(['/home']);
        this.loadingStates.offer = false;
      },
    });
  }
  goBack() {
    this.location.back();
  }

  get categories() {
    return this.offer.categories
      .map((category) => category.name)
      .sort((a, b) => a.localeCompare(b));
  }
}
